import Vue from 'vue'

const pluralize = (singleValue, pluralizedValue, count) => {
  return count == 1 ? singleValue : pluralizedValue
}

const truncate = (str, n) => {
  return str?.length > n ? str.substr(0, n - 1) + '...' : str
}

Vue.filter('pluralize', pluralize)
Vue.filter('truncate', truncate)
